// import paySetTitle from '@didi/ddpay-setTitle'
import url from './url'

const {
  appendQuery,
  parse
} = url
const ua = window.navigator.userAgent

function go(path, params = {}, isReplace) {
  const extendParams = {
    ...parse(location.search),
    ...parse(location.hash),
    ...params
  }
  const urlToGo = appendQuery(path, extendParams)

  setTimeout(() => {
    if (isReplace) {
      location.replace(urlToGo)
    } else {
      location.href = urlToGo
    }
  }, 5)
}

// function setTitle(title) {
//   if (!title) {
//     return
//   }
//   document.title = title
//   paySetTitle({
//     title
//   })
//   const iframe = document.createElement('iframe')
//   iframe.style.visibility = 'hidden'
//   iframe.style.display = 'none'
//   iframe.style.width = '0'
//   iframe.style.height = '0'
//   iframe.style.border = 'none'
//   iframe.onload = () => {
//     setTimeout(() => {
//       document.body.removeChild(iframe)
//     }, 0)
//   }
// }

function getWidthRatio() {
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0
  return width / 375
}

function getRootSize() {
  let fontSize = getWidthRatio() * 20

  if (fontSize > 25) {
    fontSize = 25
  }

  return fontSize
}

function dynamicSet() {
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0
  const fontSize = getRootSize()

  if (dynamicSet.cacheWidth === undefined || dynamicSet.cacheWidth !== width) {
    dynamicSet.cacheWidth = width
    document.documentElement.style.fontSize = `${fontSize}px`
  }
}

function setRootFontSize() {
  let count = 5
  dynamicSet()
  const timer = setInterval(() => {
    if (!count) clearInterval(timer)
    dynamicSet()
    count -= 1
  }, 200)
  window.removeEventListener('resize', dynamicSet)
  window.addEventListener('resize', dynamicSet)
}

function getScript(urlToGet, cbFn) {
  const sc = document.createElement('script')
  sc.type = 'text/javascript'

  let timeOut = false
  let timer = 0

  function load() {
    if (!this.readyState || /^(loaded|complete)$/.test(this.readyState)) {
      if (!timeOut) {
        clearTimeout(timer)
        cbFn()
      }
      sc.onload = null
      sc.onreadystatechange = null
    }
  }

  sc.onload = load
  sc.onreadystatechange = load

  sc.onerror = () => {
    if (!timeOut) {
      clearTimeout(timer)
      cbFn()
    }
    sc.onerror = null
  }

  sc.src = urlToGet

  timer = setTimeout(() => {
    timeOut = true
    cbFn()
  }, 3000)

  document.getElementsByTagName('head')[0].appendChild(sc)
}

function versionfunegt(ver1, ver2) {
  if (!ver1 || !ver2) {
    return false
  }
  const version1pre = parseFloat(ver1)
  const version2pre = parseFloat(ver2)
  const version1next = window.parseInt(ver1.replace(`${version1pre}.`, ''))
  const version2next = window.parseInt(ver2.replace(`${version2pre}.`, ''))

  if (version1pre > version2pre) {
    return true
  }
  if (version1pre < version2pre) {
    return false
  }
  if (version1next >= version2next) {
    return true
  }
  return false
}

/* eslint-disable no-useless-escape,indent */
const isAndroid = /android/i.test(ua)

const isIos = /iphone/i.test(ua)

const isWx = /MicroMessenger/i.test(ua)

const isMqq = /QQ\/([\d.]+)/.test(ua)

const isAlipay = /AlipayClient/i.test(ua)

const isMPBank = /MPBank/i.test(ua)

const isDidi = /didi/i.test(ua)

const isDidimini = /didi.mini\/([\d.]+)/.test(ua)

const isPassenger = /didi.passenger.*?\/([\d.]+)/i.test(ua)

const isNative = /didi\.passenger\/([\d\.]+)|didies/i.test(ua)

const isQYJPassenger = /didies/i.test(ua)

const isQuickapp = /com.didi.quick.passenger.*?\/([\d.]+)/i.test(ua)

const passengerInfo = ua.match(/didi.passenger.*?\/([\d.]+)/i)

const passengerVersion = passengerInfo && passengerInfo[1]
const isDriver = /didigsui.*_(.+)_\d+.*/i.test(ua) || /ddudriver.*_(\d+\.\d+\.\d+).*/i.test(ua)
const driverInfo = ua.match(/didigsui.*_(.+)_\d+.*/i) || ua.match(/ddudriver.*_(\d+\.\d+\.\d+).*/i)

const driverVersion = driverInfo && driverInfo[1]

let hostUA = ''
if (isWx) {
  hostUA = 'wx'
} else if (isMqq) {
  hostUA = 'mqq'
} else if (isAlipay) {
  hostUA = 'alipay'
} else if (isMPBank) {
  hostUA = 'MPBank'
} else if (isDidi) {
  if (isDidimini) {
    hostUA = 'didimini'
  } else {
    hostUA = 'didi'
  }
} else {
  hostUA = 'other'
}

export default {
  // setTitle,
  setRootFontSize,
  versionfunegt,
  getScript,
  isAndroid,
  isIos,
  isDidi,
  isWx,
  isMqq,
  isAlipay,
  isMPBank,
  isPassenger,
  isQYJPassenger,
  isQuickapp,
  passengerVersion,
  isDriver,
  isNative,
  driverVersion,
  hostUA,
  go
}
